import isValid from 'date-fns/isValid';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import { FormikValues } from 'formik';

export function validateDateField<T extends FormikValues>(fieldName: keyof T, values: any, validationResult: any) {
  const propValue = values[fieldName] as any;
  const date = new Date(propValue);

  if (!isValid(date)) validationResult[fieldName] = 'Неверный формат';
}

export function isDateBeforeToday(date: Date) {
  return isBefore(startOfDay(date), startOfDay(new Date()));
}
